import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found | Ecroply AI" description="The page you are looking for does not exist." path="/404" />
      <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
        <p className="text-7xl font-extrabold brand-text">404</p>
        <h1 className="mt-4 text-2xl font-bold text-slate-900">Page not found</h1>
        <p className="mt-2 text-slate-600">The tool or page you were looking for doesn’t exist.</p>
        <Link to="/" data-testid="notfound-home" className="mt-6 inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-3 rounded-xl font-semibold">
          <Home className="w-4 h-4" /> Back to home
        </Link>
      </div>
    </>
  );
}
